import { render, staticRenderFns } from "./HighTimeScores.vue?vue&type=template&id=33d3f102&scoped=true&"
import script from "./HighTimeScores.vue?vue&type=script&lang=js&"
export * from "./HighTimeScores.vue?vue&type=script&lang=js&"
import style0 from "./HighTimeScores.vue?vue&type=style&index=0&id=33d3f102&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d3f102",
  null
  
)

export default component.exports